import http from "../utils/http-common";

const get = (id: number) => {
  return http.get(`/suite/${id}`);
};
const getById = (id: number | string) => {
  return http.get(`/suite/${id}`);
};
const put = (id: number, data: any) => {
  return http.put(`/suite/${id}`, data);
};
const remove = (id: number | string) => {
  return http.delete(`/suite/${id}`);
};
const post = (data: any) => {
  return http.post(`/suite`, data);
};
const search = (data: any) => {
  return http.post(`/suite/search`, data);
};

const getAll = (params: string) => {
  const queryString = new URLSearchParams(params).toString();
  return http.get(`/suite?${queryString}`);
};
const exportSuite = (params: string) => {
  const queryString = new URLSearchParams(params).toString();
  return http.get(`/suite/export?${queryString}`);
};
const exportAutocomplete = (params: string) => {
  const queryString = new URLSearchParams(params).toString();
  return http.get(`/suite/export/autocomplete?${queryString}`);
};
const cloneSuite = (id: number | string) => {
  return http.post(`/suite/${id}/clone`);
};
const exportSuiteConfig = (id: number | string) => {
  return http.get(`/suite/${id}/export/config`);
};
const abortSuite = (id: number | string) => http.post(`/suite/${id}/abort`);
const rerunSuite = (id: number | string) => http.post(`/suite/${id}/re-run`);
export const Suite = {
  get,
  put,
  remove,
  post,
  getAll,
  getById,
  search,
  exportSuite,
  exportAutocomplete,
  cloneSuite,
  exportSuiteConfig,
  abortSuite,
  rerunSuite,
};

export default Suite;
